// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LkZ3","select":"styles_select__2mlY1"};